// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3dkvQ","col":"Table_col__30luM","fulfillmentStatus":"Table_fulfillmentStatus__3v122","emailCol":"Table_emailCol__h_e7F"};